import BaseService from '@/services/BaseService'

class BandeiraCartaoService extends BaseService {
    constructor(){
        super('/v1/bandeiras-cartoes')
    }
}

export default new BandeiraCartaoService